/* Think In · product page for retractable banners (Shopify variants: Stand / Size / Production) */
(function () {
  var dataEl = document.getElementById('ti-product-data'); if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var $ = function (id) { return document.getElementById(id); };
  var lines = function (t) { return String(t || '').split(/\r?\n/).map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); }).filter(function (p) { return p[0]; }); };
  var MODELS = {}, HINTS = {};
  lines(D.notes).forEach(function (p) { MODELS[p[0]] = { desc: p[1] || '', rec: /popular|recommended/i.test(p[2] || '') }; });
  lines(D.hints).forEach(function (p) { HINTS[p[0]] = p[1] || ''; });
  var V = D.variants, OPTS = D.options || [];
  var N = OPTS.length;
  var uniq = function (i) { var o = []; V.forEach(function (v) { if (v.o[i] && o.indexOf(v.o[i]) < 0) o.push(v.o[i]); }); return o; };
  var VALS = OPTS.map(function (_, i) { return uniq(i); });
  var iSize = OPTS.findIndex(function (n) { return /size/i.test(n); });
  var iSpeed = OPTS.findIndex(function (n) { return /production|turnaround/i.test(n); });
  var C = D.custom || null, iPrint = OPTS.findIndex(function (n) { return /^print/i.test(n); });
  var iAdd = OPTS.findIndex(function (n) { return /stake|add-on|accessor|hole|mount|grommet|easel|base|hardware|light|sandbag/i.test(n); });
  var money = function (c) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: D.currency || 'USD' }).format(c / 100); };
  var dims = function (s) { var m = (s || '').match(/(\d+(?:\.\d+)?)\D{0,3}x\D{0,3}(\d+(?:\.\d+)?)/i) || (s || '').match(/(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)/); return m ? [+m[1], +m[2]] : [24, 36]; };
  var match = function (v, sel, upto) { for (var i = 0; i < upto; i++) if (v.o[i] !== sel[i]) return false; return true; };
  var find = function (sel) { return V.find(function (v) { return match(v, sel, N); }); };

  var first = V.find(function (v) { return String(v.id) === $('ti-variant').value; }) || V[0];
  var st = { sel: first.o.slice(0, N), ship: 'ship', qty: 1, file: null };
  Object.defineProperty(st, 'size', { get: function () { if (C && st.req) return st.req.w + ' x ' + st.req.h; return iSize > -1 ? st.sel[iSize] : (D.area || '24 x 36'); } });
  Object.defineProperty(st, 'stand', { get: function () { return st.sel[0]; } });
  window.PDP = st; window.PDP_CFG = { base: D.base };
  window.tiMsg = {
    tpl: 'Template applied. Use Undo to go back.',
    start: 'We started you with a template. Replace the text or upload your own design.',
    saved: 'Your design is saved. Open the editor again to keep working.',
    pdfnote: 'PDF, AI and EPS files are checked by our team. In the editor you can place JPG and PNG.',
    adding: 'Adding your design to the cart…'
  };

  /* gallery */
  $('thumbs').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var img = $('stage-img'); if (img) { img.removeAttribute('srcset'); img.src = b.dataset.src; img.alt = b.dataset.alt || ''; }
    document.querySelectorAll('#thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
  });

  var radio = function (group, val, checked, inner, disabled) {
    var id = group + '-' + val.replace(/[^a-z0-9]+/gi, '-');
    return '<div class="choice"><input type="radio" name="ti-' + group + '" id="' + id + '" value="' + val.replace(/"/g, '&quot;') + '"' + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '><label for="' + id + '">' + inner + '</label></div>';
  };
  var pretty = function (t) { return String(t).replace(/"/g, '″'); };

  function fix() {
    for (var i = 0; i < N; i++) {
      var ok = V.some(function (v) { return match(v, st.sel, i) && v.o[i] === st.sel[i]; });
      if (!ok) { var alt = V.find(function (v) { return match(v, st.sel, i); }); if (alt) st.sel[i] = alt.o[i]; }
    }
    if (!find(st.sel)) st.sel = V[0].o.slice(0, N);
  }
  function render() {
    fix();
    var html = '';
    OPTS.forEach(function (name, i) {
      if (C && i === iSize) return;
      if (C && i === iPrint) { html += printOpt(); return; }
      var cards = i === 0 && VALS[0].some(function (x) { return MODELS[x]; });
      var body = VALS[i].map(function (val) {
        var sel = st.sel.slice(); sel[i] = val;
        var cand = V.filter(function (v) { return match(v, sel, i + 1); });
        var dis = !cand.length;
        var m = MODELS[val] || {};
        if (cards) {
          var min = cand.length ? Math.min.apply(null, cand.map(function (v) { return v.p; })) : 0;
          return radio('o' + i, val, val === st.sel[i], (m.rec ? '<span class="rec">Popular</span>' : '') + '<span class="nm">' + pretty(val) + '</span>' + (m.desc ? '<span class="ds">' + m.desc + '</span>' : '') + (min ? '<span class="pr">from ' + money(min) + '</span>' : ''), dis);
        }
        var extra = '';
        if (i === iSpeed || i === iAdd || C) {
          var here = find(sel), base = st.sel.slice(); base[i] = VALS[i][0]; var b0 = find(base);
          if (here && b0) extra = here.p > b0.p ? ' · +' + money(here.p - b0.p) : (i === iSpeed ? ' · Included' : '');
        }
        return radio('o' + i, val, val === st.sel[i], pretty(val) + extra + (m.desc ? ' <span class="ds" style="display:inline">· ' + m.desc + '</span>' : ''), dis);
      }).join('');
      html += '<div class="opt" role="radiogroup" aria-label="' + name + '"><div class="opt-h"><b>' + name + '</b><span>' + (cards ? '' : (HINTS[name] || '')) + '</span></div><div class="' + (cards ? 'models' : 'pills') + '">' + body + '</div></div>';
    });
    $('ti-opts').innerHTML = html;
    price();
  }
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' }); };
  function price() {
    var v = find(st.sel), q = Math.max(1, Math.min(500, st.qty | 0));
    if (!v) return;
    $('ti-variant').value = v.id;
    var baseSel = st.sel.slice(); if (iSpeed > -1) baseSel[iSpeed] = VALS[iSpeed][0];
    var base = find(baseSel) || v;
    $('total').textContent = money(v.p * q);
    $('per-unit').textContent = q > 1 ? money(v.p) + ' each' : '';
    var label = st.sel.filter(function (_, i) { return i !== iSpeed; }).map(pretty).join(' · ');
    $('lines').innerHTML = '<div><span>' + label + '</span><span>' + money(base.p) + '</span></div>' +
      (v.p > base.p ? '<div><span>' + st.sel[iSpeed] + '</span><span>+' + money(v.p - base.p) + '</span></div>' : '') +
      '<div><span>Shipping</span><span>At checkout</span></div>';
    var days = iSpeed > -1 && /next|rush|same/i.test(st.sel[iSpeed]) ? 1 : (+D.days || 3), ready = addBiz(new Date(), days);
    $('eta').innerHTML = 'Ships <b>' + fmt(ready) + '</b> · arrives <b>' + fmt(addBiz(ready, 3)) + ' – ' + fmt(addBiz(ready, 5)) + '</b>' + (/^\d{5}$/.test($('zip').value) ? ' to ' + $('zip').value : '');
    $('ti-prop-delivery').value = 'Ship' + (/^\d{5}$/.test($('zip').value) ? ' to ' + $('zip').value : '');
    var d = dims(st.size); sizeBox($('mock-gfx'), d[0], d[1], 120); $('mock-gfx').style.aspectRatio = '';
    if (st.file) check();
    if (C) cprice(v, q); else if (ADD.length) mprice(v, q);
  }
  $('ti-buy').addEventListener('change', function (e) {
    var t = e.target, n = t.name || '', m = n.match(/^ti-o(\d+)$/);
    if (m) { st.sel[+m[1]] = t.value; render(); }
    if (n === 'ti-pr') { st.back = t.value; st.sel[iPrint] = t.value === 'single' ? 'Single-Sided' : 'Double-Sided'; render(); }
  });
  $('qty').addEventListener('input', function () { st.qty = +$('qty').value || 1; price(); });
  $('q-minus').onclick = function () { $('qty').value = Math.max(1, (+$('qty').value || 1) - 1); st.qty = +$('qty').value; price(); };
  $('q-plus').onclick = function () { $('qty').value = Math.min(500, (+$('qty').value || 1) + 1); st.qty = +$('qty').value; price(); };
  $('zip').addEventListener('input', price);

  /* upload + resolution check */
  $('btn-upload').onclick = function () { $('upload').classList.add('on'); $('upload').scrollIntoView({ behavior: 'smooth', block: 'nearest' }); };
  function load(f) {
    if (!f) return;
    $('btn-add').disabled = false; $('ti-prop-status').disabled = true;
    if (!/^image\/(jpeg|png|webp|gif)$/.test(f.type)) {
      st.file = null; $('mock-gfx').style.backgroundImage = '';
      $('filename').textContent = f.name + ' · our team checks this file type before printing.';
      $('meter').className = 'meter ok'; $('meter').innerHTML = '<i></i><span>We will confirm resolution and size in your file check.</span>'; return;
    }
    var url = URL.createObjectURL(f), img = new Image();
    img.onload = function () { st.file = { w: img.naturalWidth, h: img.naturalHeight, name: f.name, url: url }; $('mock-gfx').style.backgroundImage = 'url(' + url + ')'; $('mock-gfx').classList.add('has'); check(); say('Here is your design on the product. Review it before adding to cart.'); };
    img.src = url;
  }
  function check() {
    var d = dims(st.size), W = d[0], H = d[1], f = st.file;
    var ppi = Math.min(f.w / W, f.h / H) | 0, ratio = (f.w / f.h) / (W / H);
    var cls = 'good', msg = '<b>' + ppi + ' PPI</b> at ' + W + '″ × ' + H + '″. Ready to print.';
    if (ppi < 100 && ppi >= 60) { cls = 'ok'; msg = '<b>' + ppi + ' PPI</b> at ' + W + '″ × ' + H + '″. Fine from a few feet away; 100+ is sharper.'; }
    if (ppi < 60) { cls = 'bad'; msg = '<b>' + ppi + ' PPI</b> at ' + W + '″ × ' + H + '″. This will print blurry. Upload a larger file or let us redesign it.'; }
    var shape = Math.abs(1 - ratio) > .08 ? ' Its shape does not match ' + W + '×' + H + '; we will show you the crop in your proof.' : '';
    $('meter').className = 'meter ' + cls; $('meter').innerHTML = '<i></i><span>' + msg + shape + '</span>';
    $('filename').textContent = f.name + ' · ' + f.w + ' × ' + f.h + ' px';
  }
  $('ti-file').addEventListener('change', function (e) { load(e.target.files[0]); });
  $('upload').addEventListener('dragover', function (e) { e.preventDefault(); });
  $('upload').addEventListener('drop', function (e) {
    e.preventDefault(); var f = e.dataTransfer.files[0]; if (!f) return;
    try { var dt = new DataTransfer(); dt.items.add(f); $('ti-file').files = dt.files; } catch (_) {}
    load(f);
  });
  $('btn-later').onclick = function () {
    $('ti-file').disabled = true; $('ti-prop-status').disabled = false; $('ti-prop-status').value = 'Customer will send the file later';
    go();
  };
  $('btn-design').onclick = function () { if (window.openEditor) window.openEditor(); };

  /* the editor calls this with the rendered design */
  window.tiSubmitDesign = function (blob, wantsProof) {
    var file = new File([blob], 'design-' + Date.now() + '.jpg', { type: 'image/jpeg' });
    try { var dt = new DataTransfer(); dt.items.add(file); $('ti-file').files = dt.files; } catch (_) { say('Your browser blocked the upload. Please download and upload your design.'); return; }
    $('ti-file').disabled = false; $('ti-prop-status').disabled = false; $('ti-prop-status').value = 'Designed online';
    $('ti-prop-proof').value = wantsProof ? 'Send PDF proof first' : 'Print after file check';
    say('adding'); go();
  };
  $('ti-buy').addEventListener('submit', function () {
    var b = $('btn-add'); if (b) { b.disabled = true; b.textContent = 'Uploading your file…'; }
    var l = $('btn-later'); if (l) l.disabled = true;
  });

  /* review before cart */
  var lastFile = null, opener = null;
  function sizeBox(el, W, H, max) { var r = W / H; el.style.width = (r >= 1 ? max : max * r) + 'px'; el.style.height = (r >= 1 ? max / r : max) + 'px'; }
  function review() {
    var f = $('ti-file').files[0]; if (!f) { say('Choose a file first.'); return; }
    var d = dims(st.size), W = d[0], H = d[1], img = st.file, art = $('rv-art'), checks = [];
    var max = Math.min(440, window.innerWidth - 120);
    sizeBox(art, W, H, Math.max(180, max));
    var m = Math.min(1, W * .08, H * .08); /* safe margin in inches */
    var sf = $('rv-safe'); sf.style.left = sf.style.right = (m / W * 100) + '%'; sf.style.top = sf.style.bottom = (m / H * 100) + '%';
    $('rv-dim').textContent = 'Print size ' + W + '″ × ' + H + '″' + (img ? ' · your file ' + img.w + ' × ' + img.h + ' px' : '');
    if (img) {
      art.className = 'rv-art'; art.style.backgroundImage = 'url(' + img.url + ')'; art.firstChild && (art.innerHTML = '<span class="rv-safe" id="rv-safe"></span>'); sf = $('rv-safe');
      sf.style.left = sf.style.right = (m / W * 100) + '%'; sf.style.top = sf.style.bottom = (m / H * 100) + '%';
      var ppi = Math.min(img.w / W, img.h / H) | 0, ratio = (img.w / img.h) / (W / H);
      if (ppi >= 100) checks.push(['', '<b>Sharp print.</b> ' + ppi + ' PPI at full size.']);
      else if (ppi >= 60) checks.push(['ok', '<b>Good from a few feet away.</b> ' + ppi + ' PPI at full size; 100+ looks sharper up close.']);
      else checks.push(['bad', '<b>This will look blurry.</b> Only ' + ppi + ' PPI at full size. Upload a larger file or ask us to redesign it.']);
      if (Math.abs(1 - ratio) > .08) checks.push(['ok', '<b>Shape does not match ' + W + '″ × ' + H + '″.</b> The preview shows what gets trimmed. Upload a file in the right proportion to avoid it.']);
      else checks.push(['', '<b>Shape matches</b> your ' + W + '″ × ' + H + '″ size.']);
      $('rv-proof').disabled = false;
    } else {
      art.className = 'rv-art doc'; art.style.backgroundImage = ''; art.innerHTML = '<span>' + f.name.replace(/</g, '&lt;') + '<br>We check this file for you</span>';
      checks.push(['info', '<b>We cannot preview this file type here.</b> Our team checks it and emails you a PDF proof before printing.']);
      $('rv-proof').checked = true; $('rv-proof').disabled = true;
    }
    if (st.sel.some(function (x) { return /double/i.test(x); })) checks.push(['info', '<b>Double sided:</b> this design prints on both sides. For a different back, upload a 2-page PDF.']);
    $('rv-tabs').hidden = !img || !window.ti3d || /shirt|tee|cap|hat|tote|apparel|runner|polo|hoodie|bottle/i.test(D.handle || ''); view('flat');
    $('rv-checks').innerHTML = checks.map(function (c) { return '<li class="' + c[0] + '"><span>' + c[1] + '</span></li>'; }).join('');
    var v = find(st.sel), q = Math.max(1, Math.min(500, st.qty | 0));
    var rows = [['Product', document.querySelector('.ti h1') ? document.querySelector('.ti h1').textContent.trim() : '']];
    OPTS.forEach(function (n, i) { rows.push([n, C && i === iSize ? reqLabel() : C && i === iPrint ? printLabel() : pretty(st.sel[i])]); });
    if (ADD.length) addSel().forEach(function (a) { rows.push([a.g, a.o[0]]); });
    if ($('ti-sizes')) rows.push(['Sizes', $('ti-sizes').value.trim() || '<span style="color:#C2352B;font-weight:600">Add your sizes</span>']);
    rows.push(['Quantity', q], ['File', f.name], ['Total', '<span class="tot">' + money(C || ADD.length ? st.total : v.p * q) + '</span>']);
    $('rv-sum').innerHTML = rows.map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + String(r[1]).replace(/<(?!\/?span)/g, '&lt;') + '</dd>'; }).join('');
    if (lastFile !== f) { $('rv-ok').checked = false; lastFile = f; }
    $('rv-go').disabled = !$('rv-ok').checked || ($('ti-sizes') && !$('ti-sizes').value.trim());
    opener = document.activeElement; $('rv').hidden = false; document.documentElement.style.overflow = 'hidden'; $('rv-x').focus();
  }
  var stop3d = null;
  function view(v) {
    document.querySelectorAll('#rv-tabs button').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.v === v ? 'true' : 'false'); });
    $('rv-flat').hidden = v !== 'flat'; $('rv-3d').hidden = v !== '3d';
    $('rv-flat').parentNode.classList.toggle('is3d', v === '3d');
    if (stop3d) { stop3d(); stop3d = null; }
    if (v === '3d' && window.ti3d && st.file) {
      var d = dims(st.size), h = D.handle || '', kind = +D.base > 0 ? 'stand' : /tent|canopy/i.test(h) ? 'tent' : /mug/i.test(h) ? 'mug' : /pole-banner/i.test(h) ? 'lightpole' : /floor|sidewalk|carpet/i.test(h) ? 'floor' : /x-stand|x-banner/i.test(h) ? 'xstand' : /table-cover|table-throw/i.test(h) ? 'table' : /feather|teardrop|custom-flags|flag-banner/i.test(h) ? 'feather' : /rider/i.test(h) ? 'panel' : /real-estate/i.test(h) ? 'post' : /a-frame|sandwich/i.test(h) ? 'aframe' : /yard|lawn/i.test(h) ? 'yard' : /alumin|metal|acrylic|foam|pvc|plastic-sign|dibond|magnet|decal|sticker|poster|canvas|lettering|menu|counter-card|card/i.test(h) ? 'panel' : 'banner';
      stop3d = window.ti3d($('rv-3d'), { url: st.file.url, W: d[0], H: d[1], kind: kind, double: st.sel.some(function (x) { return /double/i.test(x); }), gloss: /acrylic/i.test(h), car: /car-magnet|lettering|vehicle|bumper/i.test(h), canvas: /canvas/i.test(h) && !/rolled/i.test(h) ? (st.sel.find(function (x) { return /mirror|wrap|black|white/i.test(x); }) || 'mirror') : '', glass: /window/i.test(h), thin: /decal|sticker|poster|menu|card/i.test(h), backdrop: /step-and-repeat|backdrop|tension|pop-up-display/i.test(h), tear: /teardrop/i.test(h), rect: /custom-flags/i.test(h), nomask: /rectangle-flag/i.test(h), angled: /angled-flag/i.test(h), cross: st.sel.some(function (x) { return /cross/i.test(x); }), dark: st.sel.some(function (x) { return /black/i.test(x); }), withPost: !st.sel.some(function (x) { return /sign only|fabric only|graphic only|canopy only/i.test(x); }), holes: OPTS.reduce(function (r, n, i) { return /hole|mount/i.test(n) && !/none/i.test(st.sel[i]) ? st.sel[i] : r; }, '') });
    }
  }
  $('rv-tabs').addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) view(b.dataset.v); });
  function closeRv() { view('flat'); $('rv').hidden = true; document.documentElement.style.overflow = ''; if (opener && opener.focus) opener.focus(); }
  $('btn-add').onclick = review;
  $('rv-x').onclick = closeRv;
  $('rv').addEventListener('click', function (e) { if (e.target === $('rv')) closeRv(); });
  document.addEventListener('keydown', function (e) {
    if ($('rv').hidden) return;
    if (e.key === 'Escape') { closeRv(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call($('rv').querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.offsetParent; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  $('rv-ok').addEventListener('change', function () { $('rv-go').disabled = !this.checked || ($('ti-sizes') && !$('ti-sizes').value.trim()); });
  $('rv-back').onclick = function () { closeRv(); $('ti-file').click(); };
  $('rv-go').onclick = function () {
    if (!$('rv-ok').checked) return;
    $('ti-prop-proof').value = $('rv-proof').checked ? 'Send PDF proof first' : 'Print after file check';
    $('ti-prop-status').disabled = false; $('ti-prop-status').value = 'Uploaded · approved by customer';
    $('ti-file').disabled = false; $('btn-later').disabled = true;
    $('rv-go').disabled = true; $('rv-go').textContent = 'Uploading your file…'; $('rv-back').disabled = true;
    go();
  };
  /* keep only our uploader inside the form */
  (function () {
    var kill = function () { document.querySelectorAll('#ti-buy .lite-upload-body').forEach(function (n) { n.remove(); }); };
    kill(); new MutationObserver(kill).observe($('ti-buy'), { childList: true, subtree: true });
  })();
  var mb = document.querySelector('#upload .mock .base'); if (mb) mb.hidden = !(+D.base > 0);
  /* ---- custom size mode (Dibond, aluminum, reflective): any W x H, add-ons, volume tiers ---- */
  var M = D.mount || null, GRID = [], ADD = (C ? C.addons : M && M.addons) || [];
  function note(m) { if (typeof say === 'function') say(m); }
  function fmtIn(x) { return String(Math.round(x * 100) / 100); }
  function reqLabel() { if (!C) return pretty(st.size); return st.req ? fmtIn(st.req.w) + '″ × ' + fmtIn(st.req.h) + '″' : ''; }
  function printLabel() { return st.back === 'diff' ? 'Double-Sided Print (different designs)' : st.back === 'same' ? 'Double-Sided Print (same design)' : 'Single-Sided Print'; }
  function buildGrid() { GRID = VALS[iSize].map(function (s) { var d = dims(s); return { n: s, a: Math.min(d[0], d[1]), b: Math.max(d[0], d[1]) }; }); }
  function printOpt() {
    var s1 = st.sel.slice(), s2 = st.sel.slice(); s1[iPrint] = 'Single-Sided'; s2[iPrint] = 'Double-Sided';
    var a = find(s1), b = find(s2), plus = a && b && b.p > a.p ? ' · +' + money(b.p - a.p) : '';
    return '<div class="opt" role="radiogroup" aria-label="Print sides"><div class="opt-h"><b>Print sides</b><span></span></div><div class="pills">' +
      [['single', 'Single-Sided Print', ''], ['same', 'Double-Sided Print (Same Design)', plus], ['diff', 'Double-Sided Print (Different Designs)', plus]]
        .map(function (x) { return radio('pr', x[0], (st.back || 'single') === x[0], x[1] + x[2]); }).join('') + '</div></div>';
  }
  function sizeFrom() {
    var u = $('cu').value === 'ft' ? 12 : 1, w = parseFloat($('cw').value) * u, h = parseFloat($('ch').value) * u, msg = '', ok = true;
    if (!(w > 0 && h > 0)) { ok = false; msg = 'Enter the width and height.'; }
    else {
      var s = Math.min(w, h), l = Math.max(w, h), mn = C.min || 4;
      if (s < mn) { ok = false; msg = 'The smallest size we make is ' + mn + '″ × ' + mn + '″.'; }
      else if (s > C.max[0] || l > C.max[1]) { ok = false; msg = 'The largest size is ' + C.max[0] + '″ × ' + C.max[1] + '″. For bigger signs, contact us for a quote.'; }
      else {
        var best = null;
        GRID.forEach(function (g) { if (g.a >= s - .001 && g.b >= l - .001 && (!best || g.a * g.b < best.a * best.b)) best = g; });
        if (!best) { ok = false; msg = 'Contact us for this size.'; }
        else { st.sel[iSize] = best.n; if (best.a - s > .01 || best.b - l > .01) msg = 'Priced as a ' + best.a + '″ × ' + best.b + '″ panel and cut to your exact size.'; }
      }
      st.req = { w: w, h: h };
    }
    st.bad = !ok;
    $('cnote').textContent = msg; $('cnote').className = 'csz-note' + (ok ? '' : ' bad');
    render();
  }
  function addSel() {
    var r = [];
    [].forEach.call(document.querySelectorAll('#ti-adds select'), function (s) { if (s.value !== '') { var g = ADD[+s.dataset.g]; r.push({ g: g.g, o: g.o[+s.value] }); } });
    return r;
  }
  function units(o, q) {
    var dd = dims(st.size), w = st.req ? st.req.w : dd[0], h = st.req ? st.req.h : dd[1];
    if (o[3] === 'sqft') return Math.max(1, Math.ceil(w * h / 144)) * q;
    if (o[3] === 'ft') return Math.max(1, Math.ceil(2 * (w + h) / 12)) * q;
    return q;
  }
  function addName(o) { return o[0].replace(/ \(per[^)]*\)/, '').replace(/"/g, '″'); }
  function addsHtml() {
    return ADD.map(function (g, gi) {
      return '<div class="opt"><div class="opt-h"><b><label for="ad-' + gi + '">' + g.g + '</label></b><span>' + (g.hint || '') + '</span></div><select class="csel" id="ad-' + gi + '" data-g="' + gi + '"><option value="">' + g.none + '</option>' +
        g.o.map(function (o, oi) {
          var p = o[3] === 'sqft' ? money(o[2] * 100) + ' per sq ft' : o[3] === 'ft' ? money(o[2] * 100) + ' per ft of edge' : '+' + money(o[2] * 100);
          return '<option value="' + oi + '">' + addName(o) + ' · ' + p + '</option>';
        }).join('') + '</select></div>';
    }).join('');
  }
  function tier(q) { var r = [0, 0]; (C.tiers || []).forEach(function (t) { if (q >= t[0]) r = t; }); return r; }
  function cprice(v, q) {
    var sign = v.p * q, t = tier(q), disc = Math.round(v.p * t[1] / 100) * q, adds = 0, rows = '';
    addSel().forEach(function (a) {
      var u = units(a.o, q), c = Math.round(a.o[2] * 100) * u; adds += c;
      rows += '<div><span>' + addName(a.o) + (a.o[3] === 'sign' ? (q > 1 ? ' × ' + q : '') : ' · ' + u + (a.o[3] === 'sqft' ? ' sq ft' : ' ft')) + '</span><span>' + money(c) + '</span></div>';
    });
    st.total = sign - disc + adds;
    $('total').textContent = st.bad ? '—' : money(st.total);
    $('per-unit').textContent = !st.bad && q > 1 ? money(Math.round(st.total / q)) + ' each' : '';
    var desc = [reqLabel()].concat(st.sel.filter(function (_, i) { return i !== iSize && i !== iPrint; }).map(pretty), [printLabel()]).filter(Boolean).join(' · ');
    var next = (C.tiers || []).filter(function (x) { return x[0] > q; })[0];
    $('lines').innerHTML = '<div><span>' + desc + (q > 1 ? ' × ' + q : '') + '</span><span>' + money(sign) + '</span></div>' + rows +
      (disc ? '<div><span>Volume discount ' + t[1] + '% (' + t[0] + '+ signs)</span><span>−' + money(disc) + '</span></div>' : '') +
      (next ? '<div><span>Buy ' + next[0] + '+ and save ' + next[1] + '%</span><span></span></div>' : '') +
      '<div><span>Shipping</span><span>At checkout</span></div>';
    $('cp-size').value = reqLabel() + ' (cut from ' + pretty(st.sel[iSize]) + ' panel)';
    $('cp-print').value = printLabel();
    $('cp-adds').value = addSel().map(function (a) { return a.o[0]; }).join(', ') || 'None';
  }
  function go() {
    if (C && st.bad) { note($('cnote').textContent || 'Check the size.'); return; }
    var q = Math.max(1, Math.min(500, st.qty | 0)), h1 = document.querySelector('.ti h1');
    var items = ADD.length ? addSel().map(function (a) { return { id: a.o[1], quantity: units(a.o, q), properties: { 'For': (h1 ? h1.textContent.trim() : '') + ' · ' + reqLabel() } }; }) : [];
    if (!items.length) { $('ti-buy').submit(); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function () { $('ti-buy').submit(); }, function () { $('ti-buy').submit(); });
  }
  function loadAll() {
    var all = [], gq = 'query($h:String!,$c:String){product(handle:$h){variants(first:250,after:$c){pageInfo{hasNextPage endCursor}nodes{id price{amount}availableForSale selectedOptions{name value}}}}}';
    function page(c) {
      return fetch('/api/2025-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: gq, variables: { h: D.handle, c: c } }) })
        .then(function (r) { return r.json(); }).then(function (j) {
          var vs = j.data.product.variants;
          vs.nodes.forEach(function (n) {
            var o = OPTS.map(function (name) { var so = n.selectedOptions.filter(function (x) { return x.name === name; })[0]; return so ? so.value : null; });
            while (o.length < 3) o.push(null);
            all.push({ id: +n.id.split('/').pop(), o: o, p: Math.round(parseFloat(n.price.amount) * 100), a: n.availableForSale });
          });
          return vs.pageInfo.hasNextPage ? page(vs.pageInfo.endCursor) : all;
        });
    }
    return page(null).then(function (a) { if (a.length) { V.length = 0; a.forEach(function (x) { V.push(x); }); } }).catch(function () {});
  }
  function customInit() {
    var form = $('ti-buy');
    [['cp-size', 'Exact size'], ['cp-print', 'Print sides'], ['cp-adds', 'Add-ons']].forEach(function (x) { var i = document.createElement('input'); i.type = 'hidden'; i.id = x[0]; i.name = 'properties[' + x[1] + ']'; form.appendChild(i); });
    var box = document.createElement('div'); box.className = 'opt'; box.id = 'ti-size';
    box.innerHTML = '<div class="opt-h"><b>Size</b><span>Any size up to ' + C.max[0] + '″ × ' + C.max[1] + '″</span></div>' +
      '<div class="csz"><label><span>Width</span><input id="cw" inputmode="decimal" value="' + (C.w || 24) + '"></label><span class="x" aria-hidden="true">×</span><label><span>Height</span><input id="ch" inputmode="decimal" value="' + (C.h || 36) + '"></label>' +
      '<label><span>Unit</span><select id="cu" class="csel"><option value="in">Inches</option><option value="ft">Feet</option></select></label></div>' +
      '<label class="csz-std"><span>Or pick a standard size</span><select id="cstd" class="csel"><option value="">Standard sizes</option>' +
      (C.std || []).map(function (s) { return '<option value="' + s + '">' + s.replace('x', '×') + ' in</option>'; }).join('') + '</select></label><p class="csz-note" id="cnote" aria-live="polite"></p>';
    $('ti-opts').parentNode.insertBefore(box, $('ti-opts'));
    var adds = document.createElement('div'); adds.id = 'ti-adds'; adds.innerHTML = addsHtml();
    $('ti-opts').parentNode.insertBefore(adds, $('ti-opts').nextSibling);
    $('cw').addEventListener('input', sizeFrom); $('ch').addEventListener('input', sizeFrom);
    $('cu').addEventListener('change', function () { var f = this.value === 'ft' ? 1 / 12 : 12; ['cw', 'ch'].forEach(function (id) { var v = parseFloat($(id).value); if (v > 0) $(id).value = Math.round(v * f * 100) / 100; }); sizeFrom(); });
    $('cstd').addEventListener('change', function () { if (!this.value) return; var d = this.value.split('x'); $('cu').value = 'in'; $('cw').value = +d[0]; $('ch').value = +d[1]; this.value = ''; sizeFrom(); });
    adds.addEventListener('change', price);
    st.back = 'single';
    buildGrid(); sizeFrom();
    loadAll().then(function () { VALS = OPTS.map(function (_, i) { return uniq(i); }); buildGrid(); sizeFrom(); });
  }
  /* mounting add-ons on fixed-size products (holes + standoffs) */
  function mprice(v, q) {
    var adds = 0, rows = '';
    addSel().forEach(function (a) { var u = units(a.o, q), c = Math.round(a.o[2] * 100) * u; adds += c; rows += '<div><span>' + addName(a.o) + (q > 1 ? ' × ' + q : '') + '</span><span>' + money(c) + '</span></div>'; });
    st.total = v.p * q + adds;
    $('cp-adds').disabled = !adds;
    if (!adds) return;
    $('total').textContent = money(st.total);
    $('per-unit').textContent = q > 1 ? money(Math.round(st.total / q)) + ' each' : '';
    var ln = $('lines'), last = ln.lastElementChild;
    last.insertAdjacentHTML('beforebegin', rows);
    $('cp-adds').value = addSel().map(function (a) { return a.o[0]; }).join(', ');
  }
  function needHoles() {
    var so = addSel().some(function (a) { return a.g === 'Standoffs'; });
    if (!so) return;
    if (M.holesOpt) {
      var i = OPTS.indexOf(M.holesOpt[0]);
      if (i > -1 && /none/i.test(st.sel[i])) { st.sel[i] = M.holesOpt[1]; note('Standoffs need drilled holes, so we added ' + M.holesOpt[1].toLowerCase() + ' holes.'); render(); }
      return;
    }
    var hs = null; ADD.forEach(function (g, gi) { if (g.g === 'Drilled Holes') hs = $('ad-' + gi); });
    if (hs && hs.value === '') { hs.value = '0'; note('Standoffs need drilled holes, so we added 4 corner holes.'); }
  }
  function mountInit() {
    var i = document.createElement('input'); i.type = 'hidden'; i.id = 'cp-adds'; i.name = 'properties[Add-ons]'; $('ti-buy').appendChild(i);
    var adds = document.createElement('div'); adds.id = 'ti-adds'; adds.innerHTML = addsHtml();
    $('ti-opts').parentNode.insertBefore(adds, $('ti-opts').nextSibling);
    adds.addEventListener('change', function () { needHoles(); price(); });
  }
  if (C) customInit(); else { if (ADD.length) mountInit(); render(); }
})();
